import * as React from "react";
const SvgComment = props => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}><path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2" /><path fill="none" d="M0 0h24v24H0z" /></svg>;
export { SvgComment as ReactComponent };